import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UIService } from '../../../../shared/services';

@Injectable({
  providedIn: 'root',
})
export class RemoteDiagnosticsUiService {
  constructor(private uiService: UIService) {}

  virtualScrollElementHeight$: Observable<number> = this.uiService.isMobileView$.pipe(
    map((isMobile) => (isMobile ? 100 : 80))
  );
}
